const gradeClassify = r => require.ensure([], () => r(require('@/page/gradeClassify/gradeClassify')), 'gradeClassify');


const gradeClassifyRouter = {
    path: '/gradeClassify',
    name: '分级分类查询',
    component: gradeClassify,
    meta: {
        right: [],
        isShowMenu: false,
    },
    children: [
        {
            path: '/gradeClassify',
            component: gradeClassify,
            name: '分级分类查询',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive: false,
            },
        }]
};

export default gradeClassifyRouter;